import React, { FC, HtmlHTMLAttributes } from 'react';
import Tooltip from '../Tooltip';
import InfoCircle from '../Icons/outline/InfoCircle';
import LabelStyled from './LabelStyles';

interface Props extends HtmlHTMLAttributes<HTMLLabelElement> {
  children?: (string | JSX.Element)[] | JSX.Element[] | JSX.Element | string;
  subLabel?: (string | JSX.Element)[] | JSX.Element[] | JSX.Element | string;
  tooltip?: string;
  htmlFor?: string;
  longLabel?: boolean;
  tooltipOnly?: boolean;
}

const Label: FC<Props> = ({ children, subLabel, tooltip, ...props }) => {
  return (
    <LabelStyled {...props}>
      {children}
      {(subLabel || tooltip) && (
        <span className="sub-label">
          {subLabel}
          {tooltip && (
            <Tooltip
              tabIndex={0}
              theme="light"
              html={<div style={{ minWidth: 150 }}>{tooltip}</div>}
            >
              <InfoCircle />
            </Tooltip>
          )}
        </span>
      )}
    </LabelStyled>
  );
};

Label.displayName = 'Label';

export default Label;
